// extracted by mini-css-extract-plugin
export default {"NumericRangeFeature":"vx_a bhe_b bhe_wb"};